module.exports = require("./sr-Latn-ME.d.ts");